// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Site/Historia/Historia.module.css */

.Historia_mainContent__TTbI\\+ {
    padding: 20px;
    background-color: #ffffff;
    /* Cor de fundo para a área principal */
}

.Historia_introduction__\\+nsrU {
    background-color: #ffffff;
    margin-bottom: 50px;
    text-align: center;
}

.Historia_introduction__\\+nsrU h2 {
    color: #1e1e1e;
    margin-bottom: 10px;
    font-size: 2rem;
    /* Tamanho da fonte para o título */
}

.Historia_introduction__\\+nsrU p {
    color: #666;
    font-size: 1.1rem;
    /* Tamanho da fonte para o parágrafo */
    line-height: 1.6;
    /* Altura da linha para melhor leitura */
}

.Historia_timeline__5DNKc {
    position: relative;
    padding: 5px 0;
    border-left: 2px solid #074273;
    /* Linha vertical central */
    margin: 0 auto;
    max-width: 800px;
    /* Limita a largura da linha do tempo */
}

.Historia_timelineEvent__pMDGB {
    position: relative;
    padding: 20px 0;
    display: flex;
    align-items: flex-start;
    margin-left: 20px;
}

.Historia_timelineDate__65F26 {
    position: absolute;
    left: -50px;
    /* Ajusta a distância da linha central */
    width: 60px;
    height: 60px;
    background-color: #00a0e4;
    /* Cor de fundo para destacar a data */
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    line-height: 1.2;
    /* Ajusta a altura da linha para centralizar o texto */
    z-index: 1;
    /* Garante que a data esteja acima do conteúdo */
}

.Historia_timelineContent__Ov\\+pf {
    margin-left: 40px;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    max-height: 100px;
    /* Altura inicial limitada */
    overflow: hidden;
    /* Esconde o conteúdo extra */
    transition: all 0.3s ease;
    opacity: 0.8;
    transform: scale(1);
    display: flex;
    flex-direction: column;
}

.Historia_timelineContent__Ov\\+pf:hover {
    max-height: 500px;
    /* Expande a altura ao passar o mouse */
    opacity: 1;
    transform: scale(1.05);
    /* Aumenta um pouco o tamanho para um efeito de zoom */
}

.Historia_timelineContent__Ov\\+pf p {
    max-height: 50px;
    /* Exibe apenas um excerto do texto */
    overflow: hidden;
    margin: 10px 0 0;
    color: #666;
    transition: max-height 0.3s ease;
}

.Historia_timelineContent__Ov\\+pf:hover p {
    max-height: 200px;
    /* Expande o texto ao passar o mouse */
}

.Historia_timelineContent__Ov\\+pf h3 {
    margin-top: 0;
    color: #333;
}

.Historia_timelineImages__NIyP7 {
    display: flex;
    gap: 10px;
    /* Espaçamento entre as imagens */
    overflow: hidden;
    /* Oculta a rolagem horizontal */
    flex-wrap: wrap;
    /* Permite que as imagens quebrem a linha se necessário */
}

.Historia_timelineImage__KT52E {
    height: 150px;
    /* Define uma altura fixa para as imagens */
    object-fit: cover;
    /* Garante que as imagens sejam cortadas para se ajustar ao container */
    flex-shrink: 0;
    /* Evita que as imagens encolham */
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/SobreNos/Historia/Historia.module.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;IACI,aAAa;IACb,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sCAAsC;IACtC,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sDAAsD;IACtD,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;IACtB,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,UAAU;IACV,sBAAsB;IACtB,sDAAsD;AAC1D;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,iBAAiB;IACjB,uEAAuE;IACvE,cAAc;IACd,kCAAkC;AACtC","sourcesContent":["/* src/pages/Site/Historia/Historia.module.css */\r\n\r\n.mainContent {\r\n    padding: 20px;\r\n    background-color: #ffffff;\r\n    /* Cor de fundo para a área principal */\r\n}\r\n\r\n.introduction {\r\n    background-color: #ffffff;\r\n    margin-bottom: 50px;\r\n    text-align: center;\r\n}\r\n\r\n.introduction h2 {\r\n    color: #1e1e1e;\r\n    margin-bottom: 10px;\r\n    font-size: 2rem;\r\n    /* Tamanho da fonte para o título */\r\n}\r\n\r\n.introduction p {\r\n    color: #666;\r\n    font-size: 1.1rem;\r\n    /* Tamanho da fonte para o parágrafo */\r\n    line-height: 1.6;\r\n    /* Altura da linha para melhor leitura */\r\n}\r\n\r\n.timeline {\r\n    position: relative;\r\n    padding: 5px 0;\r\n    border-left: 2px solid #074273;\r\n    /* Linha vertical central */\r\n    margin: 0 auto;\r\n    max-width: 800px;\r\n    /* Limita a largura da linha do tempo */\r\n}\r\n\r\n.timelineEvent {\r\n    position: relative;\r\n    padding: 20px 0;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    margin-left: 20px;\r\n}\r\n\r\n.timelineDate {\r\n    position: absolute;\r\n    left: -50px;\r\n    /* Ajusta a distância da linha central */\r\n    width: 60px;\r\n    height: 60px;\r\n    background-color: #00a0e4;\r\n    /* Cor de fundo para destacar a data */\r\n    color: #fff;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 50%;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    line-height: 1.2;\r\n    /* Ajusta a altura da linha para centralizar o texto */\r\n    z-index: 1;\r\n    /* Garante que a data esteja acima do conteúdo */\r\n}\r\n\r\n.timelineContent {\r\n    margin-left: 40px;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    background-color: #fff;\r\n    max-height: 100px;\r\n    /* Altura inicial limitada */\r\n    overflow: hidden;\r\n    /* Esconde o conteúdo extra */\r\n    transition: all 0.3s ease;\r\n    opacity: 0.8;\r\n    transform: scale(1);\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.timelineContent:hover {\r\n    max-height: 500px;\r\n    /* Expande a altura ao passar o mouse */\r\n    opacity: 1;\r\n    transform: scale(1.05);\r\n    /* Aumenta um pouco o tamanho para um efeito de zoom */\r\n}\r\n\r\n.timelineContent p {\r\n    max-height: 50px;\r\n    /* Exibe apenas um excerto do texto */\r\n    overflow: hidden;\r\n    margin: 10px 0 0;\r\n    color: #666;\r\n    transition: max-height 0.3s ease;\r\n}\r\n\r\n.timelineContent:hover p {\r\n    max-height: 200px;\r\n    /* Expande o texto ao passar o mouse */\r\n}\r\n\r\n.timelineContent h3 {\r\n    margin-top: 0;\r\n    color: #333;\r\n}\r\n\r\n.timelineImages {\r\n    display: flex;\r\n    gap: 10px;\r\n    /* Espaçamento entre as imagens */\r\n    overflow: hidden;\r\n    /* Oculta a rolagem horizontal */\r\n    flex-wrap: wrap;\r\n    /* Permite que as imagens quebrem a linha se necessário */\r\n}\r\n\r\n.timelineImage {\r\n    height: 150px;\r\n    /* Define uma altura fixa para as imagens */\r\n    object-fit: cover;\r\n    /* Garante que as imagens sejam cortadas para se ajustar ao container */\r\n    flex-shrink: 0;\r\n    /* Evita que as imagens encolham */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContent": `Historia_mainContent__TTbI+`,
	"introduction": `Historia_introduction__+nsrU`,
	"timeline": `Historia_timeline__5DNKc`,
	"timelineEvent": `Historia_timelineEvent__pMDGB`,
	"timelineDate": `Historia_timelineDate__65F26`,
	"timelineContent": `Historia_timelineContent__Ov+pf`,
	"timelineImages": `Historia_timelineImages__NIyP7`,
	"timelineImage": `Historia_timelineImage__KT52E`
};
export default ___CSS_LOADER_EXPORT___;
